// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';
import { pure } from 'recompose';

import { Modal } from '@zapier/common-components';

import Button from 'app/common/components/Button';
import Icon from 'app/common/components/Icon';
import { ModalActions } from 'app/common/components/Modal';
import { getFailedOfChecks } from 'app/common/utils/ErrorUtils';

const UnpauseErrorModal = props => {
  let editHref = `/app/editor/${props.flowId}`;
  let editCopy = 'Edit Your Zap';

  const lastCheckError = getFailedOfChecks(props.checks) || {};

  if (
    lastCheckError.cta &&
    lastCheckError.cta.href &&
    lastCheckError.cta.text
  ) {
    editHref = lastCheckError.cta.href;
    editCopy = lastCheckError.cta.text;
  }

  const errors = _.uniq([
    ...(lastCheckError.errors || []),
    ...(lastCheckError.fixes || []),
  ]);

  if (!errors.length) {
    errors.push('Unknown error! Please edit your zap for full check.');
  }

  const bem = bemify('dashboard-modal');

  return (
    <Modal
      ariaDescribedBy="unpause-error-modal-description"
      ariaLabelledBy="unpause-error-modal-title"
      closeOnOutsideClick={true}
      onClose={props.onCloseModal}
    >
      <div className={bem()}>
        <h1 id="unpause-error-modal-title">
          There was a problem activating your Zap.
        </h1>
        <div className={bem('__list')}>
          <ul id="unpause-error-modal-description">
            {_.map(errors, (reason, i) => {
              return (
                <li key={`reason-${i}`}>
                  <Icon
                    className={bem('__list-icon')}
                    kind="is-error"
                    type="error"
                  />
                  {reason && reason.message ? reason.message : reason}
                </li>
              );
            })}
          </ul>
        </div>
        <ModalActions
          alignItems="center"
          direction="row"
          justify="center"
          margin="normal"
        >
          <Button kind="secondary large" onClick={props.onCloseModal}>
            Cancel
          </Button>
          <Button
            href={editHref}
            kind="primary large"
            onClick={props.onCloseModal}
            tag="a"
          >
            {editCopy}
          </Button>
        </ModalActions>
      </div>
    </Modal>
  );
};

UnpauseErrorModal.propTypes = {
  flowId: PropTypes.number.isRequired,
  checks: PropTypes.array.isRequired,
  onCloseModal: PropTypes.func,
};

const enhanceUnpauseErrorModal = pure;

export default enhanceUnpauseErrorModal(UnpauseErrorModal);
